export const IPEcolor = '21, 103, 237';
export const BANcolor = '20, 191, 134';
export const disabledColor = '255, 0, 0';
export const defaultColor = '0, 0, 0';

export const OrigineColors: { [char: string]: string } = {
  IPE: IPEcolor,
  BAN: BANcolor,
  '': defaultColor
};
